import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { isJrTransitIconPath } from '@this/src/util/utils';

type Props = React.ImgHTMLAttributes<HTMLImageElement>;

export const TransitCompanyImage: React.FC<Props> = ({ src, style, ...props }) => {
  const isSp = useMediaQuery('(max-width:900px)');
  const isJr = isJrTransitIconPath(src);

  return (
    <img
      src={src}
      style={{
        height: isJr && isSp ? '14px' : '20px',
        marginLeft: '5px',
        verticalAlign: 'middle',
        ...style
      }}
      {...props}
    />
  );
};
